<div class="container">
    <div class="mt-2 row">
        <div class="d-flex p-4">
            <app-search-box (search)="onSearch($event)"></app-search-box>
        </div>
    </div>
    <div class="provider-list">
        <table *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" style="width: 100%"></table>

        <ng-template #vestraUserSelectCheckboxRef let-data="adtData" let-emitter="captureEvents">
            <app-user-select-checkbox [data]="data" [selectedUserIds]="userIds" (emitter)="emitter($event)"></app-user-select-checkbox>
        </ng-template>
    </div>
</div>
